import api from '../../../../api/client';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { ConfigContext } from '../../../../contexts/ConfigContext';
import * as actionType from '../../../../store/actions';
import { useFarmProfile } from '../../../../contexts/FarmProfileContext';
import config from '../../../../config';

const NavLogo = () => {
    const configContext = useContext(ConfigContext);
    const { collapseMenu } = configContext.state;
    const { dispatch } = configContext;
    const { profile, loading } = useFarmProfile();

    let toggleClass = ['mobile-menu'];
    if (collapseMenu) {
        toggleClass = [...toggleClass, 'on'];
    }

    return (
        <React.Fragment>
            <div className="navbar-brand header-logo">
                <Link to="#" className="b-brand">
                    <div className="b-bg">
                        <img
                            className="object-contain"
                            src={`${profile?.logo_base64}`}
                            alt="Farm Logo"
                            style={{ width: '35px', height: '35px' }}
                        />
                    </div>
                    <span className="b-title text-uppercase">{profile?.name || 'Farm System'}</span>
                </Link>
                <Link
                    to="#"
                    className={toggleClass.join(' ')}
                    id="mobile-collapse"
                    onClick={() => dispatch({ type: actionType.COLLAPSE_MENU })}
                >
                    <span />
                </Link>
            </div>
        </React.Fragment>
    );
};

export default NavLogo;
